// src/utils/api.js

/**
 * Wrapper around fetch. (Auth temporarily removed — sends an anonymous user header.)
 * @param {string} url - The URL to fetch
 * @param {RequestInit} options - Fetch options (headers, method, body, etc.)
 * @returns {Promise<Response>} - The fetch response
 */
export async function apiFetch(url, options = {}) {
  // Merge headers
  const headers = {
    ...options.headers,
    'X-User-Email': 'anonymous',
  };

  // Make the fetch request with the email header
  return fetch(url, {
    ...options,
    headers,
  });
}
